import { createElement } from "@wordpress/element";
/**
 * External dependencies
 */

import { noop } from 'lodash';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { ToggleControl } from '@wordpress/components';
var defaultSettings = [{
  id: 'newTab',
  title: __('Open in New Tab'),
  checked: false
}];

var LinkControlSettingsDrawer = function LinkControlSettingsDrawer(_ref) {
  var _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? defaultSettings : _ref$settings,
      _ref$onSettingChange = _ref.onSettingChange,
      onSettingChange = _ref$onSettingChange === void 0 ? noop : _ref$onSettingChange;

  if (!settings || !settings.length) {
    return null;
  }

  var handleSettingChange = function handleSettingChange(setting) {
    return function (value) {
      onSettingChange(setting.id, value, settings);
    };
  };

  var theSettings = settings.map(function (setting) {
    return createElement(ToggleControl, {
      className: "block-editor-link-control__setting",
      key: setting.id,
      label: setting.title,
      onChange: handleSettingChange(setting),
      checked: setting.checked
    });
  });
  return createElement("fieldset", {
    className: "block-editor-link-control__settings"
  }, createElement("legend", {
    className: "screen-reader-text"
  }, __('Currently selected link settings')), theSettings);
};

export default LinkControlSettingsDrawer;